import { render, staticRenderFns } from "./BookingPage.vue?vue&type=template&id=c2c1200c&"
import script from "./BookingPage.vue?vue&type=script&lang=js&"
export * from "./BookingPage.vue?vue&type=script&lang=js&"
import style0 from "./BookingPage.vue?vue&type=style&index=0&id=c2c1200c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports